import React from "react";
import TotalsSummary from "../totalsSummary";
import Comments from "../comments";

const MailingResponseLTVSummary = ({ processedData, loading }) => {
  // Mailing Response Summary Data
  const MailingResponseSummaryData = [
    {
      label: "Mailed",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_mailedQty
          : "N/A",
    },
    {
      label: "Gross Orders",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_orders
          : "N/A",
    },
    {
      label: "Rate of Response",
      sign: "percentage",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_rorper
          : "N/A",
    },
    {
      label: "Gross Sales",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_grossSales
          : "N/A",
    },
    {
      label: "Cost",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_totalCost
          : "N/A",
    },
    {
      label: "Profit",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_profit
          : "N/A",
    },
    {
      label: "PL/Order",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_pl_order
          : "N/A",
    },
    {
      label: "Campaigns",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_campaigns
          : "N/A",
    },
    {
      label: "Average sale value",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_average_sale_value
          : "N/A",
    },
    {
      label: "",
      sign: "",
      value: "",
      empty: true,
    },
    {
      label: "Turnover/Mail",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_turnoverMail
          : "N/A",
    },
    {
      label: "Cost/Mail",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_costMail
          : "N/A",
    },
    {
      label: "PL/Mail",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_plMail
          : "N/A",
    },
    {
      label: "PL/Client",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_plClient
          : "N/A",
    },
    {
      label: "Shipped Qty",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_shippedQty
          : "N/A",
    },
    {
      label: "Gross Orders",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_orders
          : "N/A",
    },
    {
      label: "Net Orders",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_netOrders
          : "N/A",
    },
    {
      label: "Lost rate",
      sign: "percentage",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_lost_rate
          : "N/A",
    },
    {
      label: "Number of Refunds",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_refunds_count
          : "N/A",
    },
    {
      label: "Refunds",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_refunds
          : "N/A",
    },
    {
      label: "Refund rate %",
      sign: "percentage",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_refundRatePercent
          : "N/A",
    },
    {
      label: "Mailed Qty",
      sign: "integer",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_mailedQty
          : "N/A",
    },
    {
      label: "Gross Sales",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_grossSales
          : "N/A",
    },
    {
      label: "Net sales",
      sign: "dollar",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_netSales
          : "N/A",
    },
    {
      label: "%PL",
      sign: "percentage",
      value:
        processedData?.results_per_month?.totals
          ? processedData?.results_per_month?.totals?.total_PLper
          : "N/A",
    },
  ];

  // Life Time Value Data
  const lifeTimeValueData = [
    {
      label: "FE Qty Mailed",
      sign: "integer",
      value: processedData.ltv_totals?.total_fe_qty_mailed ?? " ",
    },
    {
      label: "NTF Buyers",
      sign: "integer",
      value: processedData.ltv_totals?.total_ntf_buyers ?? " ",
    },
    {
      label: "Rate of Response",
      sign: "percentage",
      value: processedData.ltv_totals?.total_rate_of_response ?? " ",
    },
    {
      label: "FE Purch",
      sign: "dollar",
      value: processedData.ltv_totals?.total_fe_purch ?? " ",
    },
    {
      label: "FE Cost",
      sign: "dollar",
      value: processedData.ltv_totals?.total_fe_cost ?? " ",
    },
    {
      label: "FE P/L",
      sign: "dollar",
      value: processedData.ltv_totals?.total_fe_pl ?? " ",
    },
    {
      label: "FE P/L per Buyer",
      sign: "dollar",
      value: processedData.ltv_totals?.total_fe_pl_per_buyer ?? " ",
    },
    {
      label: "BE Qty Mailed",
      sign: "integer",
      value: processedData.ltv_totals?.total_be_qty_mailed ?? " ",
    },
    {
      label: "BE Orders",
      sign: "integer",
      value: processedData.ltv_totals?.total_be_orders ?? " ",
    },
    {
      label: "Rate for BE",
      sign: "percentage",
      value: processedData.ltv_totals?.total_rate_for_be ?? " ",
    },
    {
      label: "BE Purch",
      sign: "dollar",
      value: processedData.ltv_totals?.total_be_purch ?? " ",
    },
    {
      label: "BE Cost",
      sign: "dollar",
      value: processedData.ltv_totals?.total_be_cost ?? " ",
    },
    {
      label: "BE P/L",
      sign: "dollar",
      value: processedData.ltv_totals?.total_be_pl ?? " ",
    },
    {
      label: "BE P/L per Buyer",
      sign: "dollar",
      value: processedData.ltv_totals?.total_be_pl_per_buyer ?? " ",
    },
    {
      label: "Qty Mailed",
      sign: "integer",
      value: processedData.ltv_totals?.total_qty_mailed ?? " ",
    },
    {
      label: "",
      sign: "",
      value: "",
      empty: true,
    },
    {
      label: "Reorder Rate",
      value: processedData.ltv_totals?.total_reorder_rate ?? " ",
    },
    {
      label: "Total Purch",
      sign: "dollar",
      value: processedData.ltv_totals?.total_total_purch ?? " ",
    },
    {
      label: "Total Cost",
      sign: "dollar",
      value: processedData.ltv_totals?.total_total_cost ?? " ",
    },
    {
      label: "Net PL",
      sign: "dollar",
      value: processedData.ltv_totals?.total_net_pl ?? " ",
    },
    {
      label: "Net P/L per Buyer",
      sign: "dollar",
      value: processedData.ltv_totals?.total_net_pl_per_buyer ?? " ",
    },
  ];


  return (
    <div className="d-flex flex-column gap-2">
      <TotalsSummary
        title="Mailing Response Summary"
        data={MailingResponseSummaryData}
        loading={loading}
      />
      <TotalsSummary
        title="Life Time Value"
        data={lifeTimeValueData}
        loading={loading}
      />
      <Comments tab_name="Mailing Response & LTV Summary" />
    </div>
  );
};

export default MailingResponseLTVSummary;
